/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Check_RunningInputs */

const vi_grower_area_camera_check_running = /** @type {(inputs: Grower_Area_Camera_Check_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang kiểm tra...`)
};

/**

* @param {Grower_Area_Camera_Check_RunningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_check_running = /** @type {((inputs?: Grower_Area_Camera_Check_RunningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Check_RunningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_check_running(inputs)
});